import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class fieldView_template extends vnTemplate {

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , idField: ko.observable("")
            , label: ko.observable("")
            , type: ko.observable("")
            , onClickEditField: function (data, event) {
                self.onClickEditField(data.id());
            }
            , onClickCancel: function (data, event) {
                self.onClickCancel();
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`
            <div class="w-form">
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button> 
                    <h3 class="form-title" data-bind="text: label"></h3>
                    <div class="w-btn">
                         <button data-bind="event: { click: onClickEditField }" class="btn icon i-edit"  type="button">Edit Field</button>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Info</strong>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                             <dl class="double-list">
                                <dt>
                                    <span>Field ESP ID</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: idField"></span>
                                </dd>
                                <dt>
                                    <span>Field Label</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: label"></span>
                                </dd>
                                <dt>
                                    <span>Field Type</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: type"></span>
                                </dd>
                             </dl>
                         </div>
                    </div>
                </div>
        `);
    }

    protected setFieldData(field) {
        this.getTemplateViewModel().id(field.id)
        this.getTemplateViewModel().idField(field.idField)
        this.getTemplateViewModel().label(field.label)
        this.getTemplateViewModel().type(field.type)
    }

    protected getTemplateName(): string {
        return "fieldView_template";
    }

    protected onClickEditField(id: any): any {
        this.caller.onClickEditField(id)
    }

    protected onClickCancel(): any {
        this.caller.onClickCancel()
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/fieldView_template.ts